module.exports = { baseURL: "https://api.inspiringhopeandfreedom.com" }
